"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSessionValue = exports.getSessionValue = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_properties_1 = require("../constants/firefly-properties");
var utilities_1 = require("../utilities");
var session_storage_1 = require("./session-storage");
function retrieveStorageValue() {
    var data = session_storage_1.retrieve(firefly_properties_1.default.IA_SESSION_STORAGE);
    if (firefly_utilities_helper_ts_1.isNullOrUndefined(data)) {
        data = {};
    }
    return data;
}
function getSessionValue(key) {
    var result;
    var data = session_storage_1.retrieve(firefly_properties_1.default.IA_SESSION_STORAGE);
    if (!firefly_utilities_helper_ts_1.isNullOrUndefined(data) && utilities_1.containsKey(data, key)) {
        result = data[key];
    }
    return result;
}
exports.getSessionValue = getSessionValue;
function setSessionValue(key, value) {
    var data = retrieveStorageValue();
    data[key] = value;
    return session_storage_1.store(firefly_properties_1.default.IA_SESSION_STORAGE, data);
}
exports.setSessionValue = setSessionValue;
